<template>
  <div
    :class="{ 'mobile-service': isMobileService }"
    class="btn-survey"
  >
    <div class="btn-survey-text" v-if="isScheduledAdmission || isAdmissionAuthorized">
      <p> Última etapa:</p>
      <p>enquanto espera atendimento, responda o questionário de saúde.</p>

    </div>
    <button
      id="exclusiveservicedesk-btn-suvey"
      class="button"
      @click="toSurvey"
    >
      Responder questionário
    </button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SurveyButton',
  props: {
    surveys: Object,
    hasVaccine: { type: Boolean, default: false },
    isAdmissionAuthorized: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
    }),
    ...mapGetters({
      isMobileService: 'isMobileService',
      isScheduledAdmission: 'global/isScheduledAdmission',
    }),
    hasVaccineOnExams() {
      const hasVaccine = this.foundedCategories.some(fnd => String(fnd.nome).toLowerCase() === 'vacina');
      return hasVaccine;
    },
  },

  methods: {
    toSurvey() {
      /* eslint-disable */
      dataLayer.push({
        event: 'responder_questionario',
      });
      /* eslint-enable */
      // this.$router.push({ name: 'questionnaires', params: { surveys: this.surveys } });
      window.open(this.surveys.link);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-survey {

  align-items: center;
  background-color: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 15px;
  padding: 24px;
  padding-bottom: 15px;
  width: 100%;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.24);

  &-text {
    padding-bottom: 10px;
  }

  p {
    color: #363636;
    font-weight: 700;
    font-size: 14px;
    line-height: 16.1px;
    text-align: center;
  }

  button {
    cursor: pointer;
    background-color: var(--color-terciary);
    border-radius: 4px;
    border: 1px solid var(--color-terciary);
    color: white;
    font-weight: var(--font-weight-bold);
    height: 48px;
    padding: 16px 24px;
    width: -webkit-fill-available;
  }

  &.mobile-service {
    background-color: white;
    border-radius: 8px;
    padding: 24px;

    p {
      color: var(--color-grey-7);
      font-size: var(--font-size-4);
    }

    button {
      border: 1px solid var(--color-terciary);
      font-weight: var(--font-weight-bold);
    }
  }
}
</style>
